import React from 'react';
import { AppBar, Toolbar, Typography, Button, IconButton, Stack, Box, Tooltip } from '@mui/material';
import { Person, PersonAdd } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export default function LandingPageLayoutDesktop({ children }) {
  const navigate = useNavigate();

  const sections = ['hero', 'problema', 'soluzioni', 'testimonianze', 'prezzi', 'contatti', 'accedi', 'registrati'];

  const scrollToSection = (id) => {
    if (id === 'accedi') navigate('/login');
    else if (id === 'registrati') navigate('/register');
    else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Box sx={{ fontFamily: 'Arial, sans-serif', color: '#2742F5', bgcolor: '#F5F7FA' }}>
      <AppBar
        position="fixed"
        sx={{ bgcolor: '#fff', color: '#2742F5', boxShadow: 1 }}
      >
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h5" sx={{ fontWeight: 600, color: '#2742F5' }}>
            DeskStudio
          </Typography>
          <Stack direction="row" spacing={2}>
            {sections.map((sec) => (
              <React.Fragment key={sec}>
                {(sec === 'accedi') ? (
                  <Tooltip title={sec === 'accedi' ? "Accedi" : "Registrati"}>
                    <IconButton
                      sx={{ bgcolor: '#2742F5', color: '#fff', '&:hover': { bgcolor: '#1B34D1' } }}
                      onClick={() => scrollToSection(sec)}
                      size="large"
                    >
                      <Person />
                    </IconButton>
                  </Tooltip>
                ) :(sec === 'registrati') ? (
                 <Tooltip title={sec === 'accedi' ? "Accedi" : "Registrati"}>
                   <IconButton
                     sx={{ bgcolor: '#2742F5', color: '#fff', '&:hover': { bgcolor: '#1B34D1' } }}
                     onClick={() => scrollToSection(sec)}
                     size="large"
                   >
                     <PersonAdd />
                   </IconButton>
                 </Tooltip>
               ): (
                  <Button
                    sx={{ color: '#2742F5', fontWeight: 500 }}
                    onClick={() => scrollToSection(sec)}
                  >
                    {sec.charAt(0).toUpperCase() + sec.slice(1)}
                  </Button>
                )}
              </React.Fragment>
            ))}
          </Stack>
        </Toolbar>
      </AppBar>

      <Box sx={{ mt: 10 }}>{children}</Box>
    </Box>
  );
}